import { render, staticRenderFns } from "./ResultTab.vue?vue&type=template&id=04e3bb26&scoped=true&"
import script from "./ResultTab.vue?vue&type=script&lang=ts&"
export * from "./ResultTab.vue?vue&type=script&lang=ts&"
import style0 from "./ResultTab.vue?vue&type=style&index=0&id=04e3bb26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e3bb26",
  null
  
)

export default component.exports